import { render } from "./ListButtonDocuProj.vue?vue&type=template&id=68db89d2"
import script from "./ListButtonDocuProj.vue?vue&type=script&lang=js"
export * from "./ListButtonDocuProj.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__